import React from "react";

const packages = [
  {
    value: "standart",
    title: "STANDART",
    price: "100€ + паливо",
    features: [
      "Дослідження вузлів та агрегатів",
      "Комп’ютерна діагностика всіх систем",
      "Зчитування параметрів у реальному часі",
      "Фото/відеозвіт (до 50 матеріалів)",
      "Вимірювання ЛКП, у т.ч. пошук розумної шпаклівки",
      "Візуалізація ЛКП (PDF)",
      "Тест-драйв",
      "Звіт на фірмовому бланку з оцінкою ТЗ (PDF)",
    ],
    description: "Підходить тим, хто сам знайшов авто, але хоче стандартну перевірку перед покупкою.",
  },
  {
    value: "profi",
    title: "PROFI",
    price: "200€ + паливо",
    features: [
      "Все з попереднього пакета",
      "Ендоскопія технологічних отворів",
      "Вимірювання щільності рідин ареометром",
      "Тест АКБ",
      "Тест системи охолодження на наявність CO₂",
      "Звіт CarVertical",
    ],
    description: "Вибір більшості. Глибока перевірка з документальним підтвердженням і реальними значеннями.",
  },
  {
    value: "premium",
    title: "PREMIUM",
    price: "500€ + паливо",
    features: [
      "Все з попередніх пакетів",
      "Викуп або завдаток на авто",
      "Торг із продавцем",
      "Угода під ключ",
      "Підготовка до експорту або реєстрації в ЄС",
      "Транзитні номери",
    ],
    description: "Для тих, хто хоче довірити перевірку та оформлення “під ключ”.",
  },
  {
    value: "vip",
    title: "VIP «ALL IN»",
    price: "від 1500€",
    features: [
      "Все з попередніх пакетів",
      "Пошук авто «до переможного»",
      "Доставка в Україну/ЄС",
      "Оформлення імпорту/експорту",
      "Сертифікація",
      "ТО, дітейлінг — за домовленістю",
    ],
    description: "Максимальний комфорт: ти просто забираєш готове авто, усе інше робимо ми.",
  },
];

export default function PricingPackages({ scrollToForm }) {
  return (
    <section id="packages" style={{ padding: "120px 20px", textAlign: "center" }}>
      <h2 style={{ fontSize: "32px", marginBottom: "40px" }}>Наші пакети послуг</h2>
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          gap: "20px",
          flexWrap: "wrap",
          maxWidth: "1300px",
          margin: "0 auto",
        }}
      >
        {packages.map((pkg, index) => (
          <div
            key={index}
            style={{
              backgroundColor: "#121212",
              borderRadius: "16px",
              padding: "30px",
              width: "220px",
              boxShadow: "0 0 10px rgba(255, 255, 255, 0.05)",
              textAlign: "left",
              color: "#ccc",
              flexShrink: 0,
              display: "flex",
              flexDirection: "column",
              justifyContent: "space-between",
              minHeight: "440px",
            }}
          >
            <h3 style={{ fontSize: "24px", marginBottom: "10px", color: "#facc15" }}>{pkg.title}</h3>
            <p style={{ fontWeight: "bold", color: "#fff", marginBottom: "15px" }}>{pkg.price}</p>
            <ul style={{ paddingLeft: "20px", fontSize: "15px", marginBottom: "10px" }}>
              {pkg.features.map((f, i) => (
                <li key={i}>• {f}</li>
              ))}
            </ul>
            <p style={{ fontStyle: "italic", marginBottom: "20px" }}>{pkg.description}</p>
            <button
              onClick={() => scrollToForm(pkg.value)}
              style={{
                backgroundColor: "#facc15",
                color: "#000",
                border: "none",
                borderRadius: "8px",
                padding: "10px 16px",
                fontWeight: "bold",
                cursor: "pointer",
                width: "80%",
                alignSelf: "center",
                marginTop: "auto",
              }}
            >
              Відправити заявку
            </button>
          </div>
        ))}
      </div>
    </section>
  );
}
